<template>
  <nav
    class="navbar top-navbar navbar-expand is-sticky"
    v-bind:class="{ 'toggle-navbar-area': isOpen }"
  >
    <div class="collapse navbar-collapse" id="navbarSupportContent">
      <div
        class="responsive-burger-menu d-block d-lg-none"
        v-bind:class="{ active: isOpenMobile }"
        @click="$emit('toggle-sidebar-mobile')"
      >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
      </div>

      <div class="navbar-nav left-nav align-items-center">
        <div class="nav-item">
          <div class="form-search">
            <div class="company-name" style="color: white;">
              <p style="color: white !important;">Phần mềm Next Agent</p>
            </div>
          </div>
        </div>
      </div>
      <ul class="navbar-nav right-nav align-items-center">
        <b-dropdown class="no-after dropdown profile-nav-item pr-3" variant="link">
          <template #button-content>
            <div class="menu-profile">
              <span class="name fonsize-12">{{ dataUser.name }}</span>
              <img
                src="../../assets/img/avatar1.png"
                class="rounded-circle"
                alt="image"
              />
            </div>
          </template>
          <b-dropdown-item v-if="dataUser.type !== 'AGENT_BANK'" @click="$router.push('/commission-clause')">
            <div class="dropdown-body">
              <ul class="profile-nav p-0">
                <li class="nav-item">
                  <div class="nav-link pl-0">
                    <div class="content">
                      <i class="bx bxs-florist"></i>
                      <span class="d-block pl-4">Chính sách hoa hồng</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-dropdown-item>
          <b-dropdown-item  v-if="dataUser.type !== 'AGENT_BANK'" @click="$router.push('/profile')">
            <div class="dropdown-body">
              <ul class="profile-nav p-0">
                <li class="nav-item">
                  <div class="nav-link pl-0">
                    <i class="bx bxs-user"></i>
                    <div class="content">
                      <span class="d-block pl-4">Thông tin tài khoản</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$router.push('/profile/change-password')">
            <div class="dropdown-body">
              <ul class="profile-nav p-0">
                <li class="nav-item">
                  <div class="nav-link pl-0">
                    <i class="bx bxs-key"></i>
                    <div class="content">
                      <span class="d-block pl-4">Đổi mật khẩu</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            <div class="dropdown-footer" style="margin-top: -10px;">
              <ul class="profile-nav">
                <li class="nav-item">
                  <a class="nav-link pl-1">
                    <span class="sub-img">
                      <img
                        src="../../assets/img/logout.svg"
                        alt="logout"
                        class="drop-ft-img"
                      />
                    </span>
                    <p class="pl-4 color-707070">Đăng xuất</p>
                  </a>
                </li>
              </ul>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </ul>
    </div>
    <VueLoadingOverlay :active.sync="showLoading"
        :is-full-page="true">
    </VueLoadingOverlay>
  </nav>
</template>

<script>

export default {
  name: 'Header',
  components: {
  },

  data () {
    return {
      showLoading: false,
      dataUser: JSON.parse(localStorage.getItem('userData')) ?? {}
    }
  },
  props: {
    headerbg: String,
    isOpen: Boolean,
    isOpenMobile: Boolean
  },
  methods: {
    async logout () {
      try {
        this.showLoading = true
        await this.$store.dispatch('user/clear')
        await this.$store.dispatch('role/clear')
        await this.$store.dispatch('auth/logout')
      } catch (error) {
      }
    }
  }
}
</script>

<style scoped>
.app-header {
  left: 210px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0;
  height: 52px;
  background: #0b62ab !important;
  padding-left: 10px;
  padding-right: 10px;
}
.menu-profile {
  transform: translate(1rem, 0);
}
.dropdown .dropdown-toggle::after {
  display: none !important;
}
</style>
